import {SurveyState} from 'client/common/store/reducers/survey/types';
import {Creative as CreativeData, SurveySlug, VideoService, BoxType, ToBench} from 'client/common/types';

export interface CreativeFields {
    brand: string;
    industry: number;
    targeting: string;
    additionalParameters: string;
}

export const CREATIVE_INFO_FIELDS: (keyof CreativeFields)[] = [
    'brand',
    'industry',
    'targeting',
    'additionalParameters'
];

export interface Creative extends CreativeFields {
    slug: SurveySlug;
    name: string;
    state: SurveyState;
    creative: CreativeData;
    isDemo?: boolean;
    stat?: {
        index?: {
            value: number;
            toBench: ToBench;
        };
    };
}

export interface CreativeCreateData {
    id: string;
    service: VideoService | 'resource';
    title: string;
    duration: number;
}

export type CreativesBoxType = Extract<BoxType, 'creative' | 'bordomatik'>;
